import SplashScreen from "./Pages/SplashScreen";
import Pages from "./Pages";
import { useTheme } from './Contexts/ThemeProvider';

export default function App() {
  const {isLoadingStartApp} = useTheme();
  return isLoadingStartApp ? <SplashScreen /> : <Pages />;
}
